import { render, staticRenderFns } from "./PreviewImageModal.vue?vue&type=template&id=3db68592&scoped=true"
import script from "./PreviewImageModal.vue?vue&type=script&lang=js"
export * from "./PreviewImageModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewImageModal.vue?vue&type=style&index=0&id=3db68592&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db68592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db68592')) {
      api.createRecord('3db68592', component.options)
    } else {
      api.reload('3db68592', component.options)
    }
    module.hot.accept("./PreviewImageModal.vue?vue&type=template&id=3db68592&scoped=true", function () {
      api.rerender('3db68592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/PreviewImageModal.vue"
export default component.exports